export type WrapupFeedbackThankYouSentiment = 'positive' | 'negative' | null;

export const FEEDBACK_SUBMIT_THANK_YOU_TITLE_POSITIVE = "I'm so glad I could help!";
export const FEEDBACK_SUBMIT_THANK_YOU_TITLE_NEGATIVE =
  "I'll use this to continue improving over time.";
export const FEEDBACK_SUBMIT_THANK_YOU_TITLE_FALLBACK = 'Thank you for your feedback';

export function getFeedbackSubmitThankYouDescription(
  sentiment: WrapupFeedbackThankYouSentiment,
): string | undefined {
  if (sentiment === 'positive') {
    return FEEDBACK_SUBMIT_THANK_YOU_TITLE_POSITIVE;
  }
  if (sentiment === 'negative') {
    return FEEDBACK_SUBMIT_THANK_YOU_TITLE_NEGATIVE;
  }
  return undefined;
}
